// src/components/TrainerColorLegend.js

import React from 'react';
import {
    Box,
    Typography,
    Chip,
    Paper,
    Collapse,
    IconButton
} from '@mui/material';
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import PersonIcon from '@mui/icons-material/Person';

const LegendPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1]
}));

// Same color palette as in TrainerSchedule
const trainerColors = [
    { bg: '#1976d2', text: '#ffffff' }, // Blue
    { bg: '#388e3c', text: '#ffffff' }, // Green
    { bg: '#f57c00', text: '#ffffff' }, // Orange
    { bg: '#7b1fa2', text: '#ffffff' }, // Purple
    { bg: '#d32f2f', text: '#ffffff' }, // Red
    { bg: '#00796b', text: '#ffffff' }, // Teal
    { bg: '#5d4037', text: '#ffffff' }, // Brown
    { bg: '#303f9f', text: '#ffffff' }, // Indigo
    { bg: '#c2185b', text: '#ffffff' }, // Pink
    { bg: '#455a64', text: '#ffffff' }, // Blue Grey
    { bg: '#6a1b9a', text: '#ffffff' }, // Dark Purple
    { bg: '#2e7d32', text: '#ffffff' }, // Dark Green
    { bg: '#e65100', text: '#ffffff' }, // Deep Orange
    { bg: '#ad1457', text: '#ffffff' }, // Deep Pink
    { bg: '#1565c0', text: '#ffffff' }, // Dark Blue
];

export default function TrainerColorLegend({ trainers, expanded, onToggle }) {
    const getTrainerColor = (trainerIndex) => {
        const colorIndex = trainerIndex % trainerColors.length;
        return trainerColors[colorIndex];
    };

    return (
        <LegendPaper>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                cursor: 'pointer',
                mb: expanded ? 2 : 0
            }} onClick={onToggle}>
                <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center' }}>
                    <PersonIcon sx={{ mr: 1 }} />
                    Trainer Colors
                </Typography>
                <IconButton size="small">
                    {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
            </Box>

            <Collapse in={expanded}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {/* Unassigned/Not Payable Color */}
                    <Chip
                        label="Unassigned / Not Payable"
                        sx={{
                            backgroundColor: '#f5f5f5',
                            color: '#666666',
                            border: '1px solid #e0e0e0',
                            '& .MuiChip-label': {
                                fontWeight: 500
                            }
                        }}
                        size="small"
                    />

                    {/* Trainer Colors */}
                    {trainers.map((trainer, index) => {
                        const color = getTrainerColor(index);
                        return (
                            <Chip
                                key={trainer.trainerId}
                                label={trainer.fullName}
                                sx={{
                                    backgroundColor: color.bg,
                                    color: color.text,
                                    '& .MuiChip-label': {
                                        fontWeight: 500
                                    }
                                }}
                                size="small"
                            />
                        );
                    })}
                </Box>

                <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
                    Each trainer has a unique color. Classes that are not payable appear in gray regardless of trainer assignment.
                </Typography>
            </Collapse>
        </LegendPaper>
    );
}